import { render, staticRenderFns } from "./popover_info.vue?vue&type=template&id=5c63d840"
import script from "./popover_info.vue?vue&type=script&lang=js"
export * from "./popover_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports